export const LoggerLevelsArray = [
    "error",
    "warn",
    "info",
    "http",
    "verbose",
    "debug",
    "silly",
];
const compatibilityLevels = {
    error: console.error,
    warn: console.warn,
    info: console.info,
    log: console.log,
    http: console.log,
    verbose: console.log,
    debug: console.debug,
    silly: console.log,
};
const generateLevelInput = (level, size = 5) => `${Array.from({ length: size - level.length }, () => " ").join("")}${level}`;
export function consoleLogTransport(info) {
    compatibilityLevels[info.level](`(${new Date().toLocaleString()}) ${generateLevelInput(info.level)} [${info.meta.level.join(" > ")}]:`, ...info.message);
}
export class Logger {
    static child(options) {
        return new Logger(options);
    }
    constructor(options) {
        var _a, _b, _c, _d;
        this.options = options || {};
        if (this.options.parentLogger) {
            this.name = (_a = this.options.name) !== null && _a !== void 0 ? _a : "";
            this.nameLevel = [
                ...this.options.parentLogger.nameLevel,
                this.name,
            ];
            this.level = this.options.parentLogger.level;
            this.callback = this.options.parentLogger.callback.bind(this.options.parentLogger);
        }
        else {
            this.level = (_b = this.options.level) !== null && _b !== void 0 ? _b : "info";
            this.callback = (_c = this.options.callback) !== null && _c !== void 0 ? _c : (() => { });
            this.name = (_d = this.options.name) !== null && _d !== void 0 ? _d : "";
            this.nameLevel = [this.name];
        }
    }
    execute(level, ...message) {
        if (LoggerLevelsArray.indexOf(level) <=
            LoggerLevelsArray.indexOf(this.level)) {
            this.callback({
                level,
                message,
                meta: {
                    level: this.nameLevel,
                },
            });
        }
    }
    error(...message) {
        this.execute("error", ...message);
    }
    warn(...message) {
        this.execute("warn", ...message);
    }
    info(...message) {
        this.execute("info", ...message);
    }
    log(...message) {
        this.execute("info", ...message);
    }
    http(...message) {
        this.execute("http", ...message);
    }
    verbose(...message) {
        this.execute("verbose", ...message);
    }
    debug(...message) {
        this.execute("debug", ...message);
    }
    silly(...message) {
        this.execute("silly", ...message);
    }
    trace(...message) {
        this.execute("silly", ...message);
    }
}
//# sourceMappingURL=logger.util.js.map